// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2TiyT","inputSuccess":"FieldCurrencyInput_inputSuccess__1-JRC","inputError":"FieldCurrencyInput_inputError__2nSa8"};